// src/padplanner/IntendedLandownerField.jsx
//
// "Requires landowner approval" (158), on New plan and in Edit details: a
// switch, and when it is on, the landowner, from the org's live
// relationships (GET …/landowner-relationships). The rules are landowner.js's;
// the server checks the relationship again when the plan is saved.
//
// `value` is null (off), "" (on, none chosen yet) or an org id. With exactly
// one live relationship, turning it on chooses that one. With none, the
// switch is off and says why. `current` is the plan's own landowner in Edit
// details: offered even when its relationship is gone, so keeping it is not
// a change. `lockedReason` (landowner.js's intendedLocked) shows the value
// read-only, with the reason.
import { liveLandowners, NO_RELATIONSHIP_TEXT, RELATIONSHIPS_FAILED_TEXT } from "./landowner";

const field = "rounded border border-bg-border bg-bg px-2 py-1.5 text-[13px] text-fg-primary";

export default function IntendedLandownerField({ relationships, failed = false, value, onChange, current = null, lockedReason = null }) {
  const live = liveLandowners(relationships);
  const options = [...live];
  if (current && !options.some((o) => o.id === current.org_id)) {
    options.unshift({ id: current.org_id, name: `${current.name ?? "This plan's landowner"} (no longer accepts submissions)` });
  }
  const on = value !== null;
  const none = Boolean(relationships) && options.length === 0;
  const disabled = Boolean(lockedReason) || failed || !relationships || none;
  const note = lockedReason ?? (failed ? RELATIONSHIPS_FAILED_TEXT : none ? NO_RELATIONSHIP_TEXT : null);

  return (
    <div className="flex flex-col gap-1.5" data-testid="pp-intended-field">
      <button type="button" role="switch" aria-checked={on} disabled={disabled} data-testid="pp-intended-switch"
        onClick={() => onChange(on ? null : (live.length === 1 ? live[0].id : ""))}
        className="flex items-center gap-2 self-start text-[13px] text-fg-primary disabled:text-fg-secondary">
        <span aria-hidden="true" className={`relative inline-flex h-4 w-7 shrink-0 rounded-full border transition-colors ${on ? "border-accent-action bg-accent-action" : "border-bg-border bg-bg-softer"}`}>
          <span className={`absolute top-[1px] h-3 w-3 rounded-full bg-white transition-all ${on ? "left-[13px]" : "left-[1px]"}`} />
        </span>
        Requires landowner approval
      </button>
      {on && (
        <label className="flex flex-col gap-1">
          <span className="op-label uppercase">Landowner</span>
          <select value={value} disabled={Boolean(lockedReason)} onChange={(e) => onChange(e.target.value)}
            className={field} data-testid="pp-intended-select">
            <option value="">Choose a landowner</option>
            {options.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
          </select>
        </label>
      )}
      {note && <p className="op-meta" data-testid="pp-intended-note">{note}</p>}
    </div>
  );
}
